/* Dialog layout */

.af-dialog {
  ux-dialog-body {
    display: flex
  }

  &__icon {
    padding-right: 15px
  }

  &__main {
    flex-grow: 1;
  }

  &__json {
    width: 100%;
    height: 200px;
    overflow: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-bottom: 0;
    padding: 4px;
    font-size: small;
    background-color: white;
  }
}
